import type { TStaffMember } from "../../models/staff-member-model";

export type StaffMemberProps = {
  staffMember: TStaffMember;
  initials?: boolean;
};

export const StaffMemberPresentational = (props: StaffMemberProps) => (
  <div className="flex flex-row items-center">
    <div
      className="px-2 py-1 rounded"
      style={{
        border: props.staffMember.strokeColor,
        background: props.staffMember.fillColor,
      }}
    >
      <div className="text-ellipsis whitespace-nowrap overflow-hidden font-semibold">
        {props.initials ? props.staffMember.initials : props.staffMember.name}
      </div>
    </div>
  </div>
);
